export enum StorageKeys {
    PaperCompanyValues = "PaperCompanyValues"
}
